import * as Yup from 'yup';

export const MapStayFormValidationSchema = Yup.object().shape({
  stayUuid: Yup.string().nullable().required('This field is required'),
  externalStayUuid: Yup.string().nullable().required('This field is required'),
  externalSupplier: Yup.string().nullable().required('This field is required'),
});
